/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-redux/~/lodash/_freeGlobal.js
 ** module id = 45
 ** module chunks = 0
 **/